import React, { useEffect } from 'react';
import { connect } from 'react-redux';

// import ConvertTextToSpeech from '../../customeHooks/convertTextToSpeech';

const mapStateToProps = (state) => {
    const {
        rightFeedbackProps,
        answerCount,
        leftFeedbackProps,
    } = state.rootReducer.testPageDetails;

    return {
        rightFeedbackProps,
        answerCount,
        leftFeedbackProps,
    }
}

const SpeechIncorrect = ({
    answerCount,
    rightFeedbackProps: {
        feedbackQuestionNo,
        feedbackQuestion,
        defaultFeedback,
        correctAnswer,
        score,
        fileUrl,
    },
    leftFeedbackProps: {
        questionId,
        qtype,
    },

}) => {
    // useEffect(() => {
    //     ConvertTextToSpeech({ correctAnswer, elementClass: 'correct-answer-', questionId, score });
    // }, [correctAnswer,
    //     questionId,
    //     score,
    // ])
    return (
        <span> 
              <h4 className="text-danger">That’s Incorrect.</h4>
              <div className="record-container">
                 <div className="audio-player audio-player-wrong">
                    <audio src={fileUrl} controls controlsList="nodownload"></audio>
                    <small>Your answer</small>
                 </div>

                {qtype !== 'LA' && 
                    <div className="audio-player audio-player-correct">
                        <audio src="" controls controlsList="nodownload" id={'correct-answer-'+questionId}></audio>
                        <small>Check this correct answer</small>
                     </div>}
              </div>
              <input type="hidden" name="choosen-answer" className="choosen-answer" />
           </span>
    );
}





export default connect(mapStateToProps)(SpeechIncorrect);